"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from "react";
import { cj, KEY_CODES } from "../utils";
import { NavbarContext } from "./shared/navbarContext";
import { DropdownContext } from "./shared/dropdownContext";
const DropdownToggle = /*#__PURE__*/ React.forwardRef(function DropdownToggle(_param, ref) {
    var { tag = "div", className = "" } = _param, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    const { isOpen, toggleOpen, hover } = React.useContext(DropdownContext);
    const { isOpen: isNavbarOpen } = React.useContext(NavbarContext);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({}, props), {
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        className: cj(className, "w-dropdown-toggle", isNavbarOpen && "w--nav-dropdown-toggle-open"),
        onClick: ()=>{
            if (!hover) toggleOpen();
        },
        onKeyDown: (e)=>{
            if (e.key === KEY_CODES.ENTER || e.key === KEY_CODES.SPACE) {
                toggleOpen();
                e.stopPropagation();
                return e.preventDefault();
            }
        },
        role: "button",
        tabIndex: 0,
        ref
    }));
});
export default DropdownToggle;
